import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';

import { ApiClientError } from '@/shared/api';

/**
 * Puts the server's field errors on the form and returns the message for the form itself.
 * Fields the form does not have stay in the returned message.
 */
export function applyServerErrors<T extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<T>,
  fields: ReadonlyArray<Path<T>>,
): string {
  if (!(error instanceof ApiClientError)) return 'Что-то пошло не так. Попробуйте ещё раз';
  let matched = false;
  for (const [field, message] of Object.entries(error.fields)) {
    if ((fields as readonly string[]).includes(field)) {
      setError(field as Path<T>, { type: 'server', message });
      matched = true;
    }
  }
  return matched && error.code === 'validation_failed' ? '' : error.message;
}
